import { useQuery } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { Subscription, SubscriptionStatus } from '@/shared/types/Billing';

import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

export const useIsPaidTrial = (subscription: null | Subscription | undefined): boolean | undefined => {
  const isTrialing = subscription?.status === SubscriptionStatus.Trialing;
  const userQuery = useQuery({
    enabled: isTrialing,
    queryFn: API.getUser,
    queryKey: USER_QUERY_KEYS.userData,
    refetchOnMount: false,
    retryOnMount: false,
  });
  const user = userQuery.data;
  const access = useQuery({
    enabled: user?.subscription?.status === SubscriptionStatus.Trialing,
    queryFn: API.getPaidTrialAccess,
    queryKey: USER_QUERY_KEYS.paidTrialAccess(user?.id),
    retry: false,
    staleTime: 5 * 60_000,
  });
  if (!isTrialing) return false;
  if (userQuery.isPending) return undefined;
  if (!user) return false;
  if (subscription.user_id !== user.id || subscription.id !== user.subscription?.id) return false;
  if (access.isLoading) return undefined;
  return access.data?.recording_unlimited === true;
};
